"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var util_1 = require("../util");
var renderProp_1 = tslib_1.__importDefault(require("../util/renderProp"));
var throttle_debounce_1 = require("throttle-debounce");
var SyncSensor = (function (_super) {
    tslib_1.__extends(SyncSensor, _super);
    function SyncSensor(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = props.initial || {};
        _this.onEvent = throttle_debounce_1.throttle(_this.props.throttle, false, function (event) {
            var state = _this.props.onEvent(event);
            _this.setState(state, function () {
                (_this.props.onChange || util_1.noop)(_this.state);
            });
        });
        return _this;
    }
    SyncSensor.prototype.componentDidMount = function () {
        this.props.addListener(this.onEvent);
    };
    SyncSensor.prototype.componentWillUnmount = function () {
        this.props.removeListener(this.onEvent);
    };
    SyncSensor.prototype.render = function () {
        return renderProp_1.default(this.props, this.state);
    };
    SyncSensor.defaultProps = {
        throttle: 100
    };
    return SyncSensor;
}(React.Component));
exports.SyncSensor = SyncSensor;
//# sourceMappingURL=index.js.map